import { useQuery } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

export interface City {
  id: string
  name: string
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

export const useCities = () => {
  const fetchWithAuth = useFetchWithAuth()

  return useQuery({
    queryKey: ['cities'],
    queryFn: async () => {
      const response = await fetchWithAuth(`${API_URL}/cities`)
      return response as City[]
    },
  })
}
